import Vue from 'vue'
import VueRouter from 'vue-router'
import store from "../store/index.js";
import Cookies from "js-cookie";

import Begin from '../views/Begin.vue'
import Test from '../components/containers/Navbar.vue'


import Login from '../views/Login.vue'
import Home from '../views/Home.vue'
import Users from '../views/Users.vue'
import InvestPublicDetails from '../views/InvestPublicDetails.vue'
import UserDetails from '../views/UserDetails.vue'
import Withdraw from '../views/Withdraw.vue'
import Invest from '../views/Invest.vue'
import InvestPublic from '../views/InvestPublic.vue'
import PaymentReports from '../views/PaymentReports.vue'
import WithdrawReports from '../views/WithdrawReports.vue'
import Report from '../components/WithdrawReports/Report.vue'
import EarningLost from '../views/EarningOrLost.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Begin',
    component: Begin
  },
  {
    path: '/home',
    name: 'Test',
    component: Test,
    children: [
      {
        path: '/admin/home',
        name: 'Home',
        component: Home,
        meta: { requiresAuth: true }
      },
      {
        path: '/admin/users',
        name: 'Users',
        component: Users,
        meta: { requiresAuth: true }
      },
      // Should be users children routes
      {
        path: '/admin/users/:user_id',
        name: 'User details',
        component: UserDetails,
        meta: { requiresAuth: true }
      },
      // End of what should be users children

      {
        path: '/admin/withdraw',
        name: 'Withdraw',
        component: Withdraw,
        meta: { requiresAuth: true }
      },
      {
        path: '/admin/invest',
        name: 'Invest',
        component: Invest,
        meta: { requiresAuth: true }
      },
      {
        path: '/admin/invest_public',
        name: 'InvestPublic',
        component: InvestPublic,
        meta: { requiresAuth: true }
      },

      // Should be users children routes
      {
        path: '/admin/invest_public/:invest_id',
        name: 'InvestPublicDetails',
        component: InvestPublicDetails,
        meta: { requiresAuth: true }
      },
      {
        path: '/admin/payment_reports',
        name: 'PaymentReports',
        component: PaymentReports,
        meta: { requiresAuth: true }
      },
      {
        path: '/admin/withdraw_reports',
        name: 'WithdrawReports',
        component: WithdrawReports,
        meta: { requiresAuth: true }
      },
      {
        path: '/admin/withdraw_reports/:id',
        name: 'Report',
        component: Report,
        meta: { requiresAuth: true }
      },
      {
        path: '/admin/earning_lost',
        name: 'EarningLost',
        component: EarningLost,
        meta: { requiresAuth: true }
      },
    ]
  },
  {
    path: '/admin/login',
    name: 'Login',
    component: Login
  }

]


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  const accessToken = Cookies.get("access_token");
  if (to.matched.some(record => record.meta.requiresAuth) && !store.state.status && !accessToken) {
    alert('Debe iniciar sesión para continuar')
    next("/admin/login");
  } else if (store.state.status && accessToken) {
    console.log('logged')
    next()
  } else {
    next()
  }
})

export default router
